module.exports = __webpack_public_path__ + "static/media/GuncelSenaryo.8fc9920e.png";